import React from "react";
import { Link } from "react-router-dom";
import "../../assets/css/Footer.css";

function Footer() {
  return (
    <footer>
      <div className="container">
        {/* ── MAIN CONTENT ────────────────────────────────────────────── */}
        <div className="footer-content">
          
          {/* Left Section - About */}
          <div className="footer-left footer-section">
            <h6>À Propos</h6>
            <ul>
              <li><Link to="/">À Propos de Nous</Link></li>
              <li><Link to="/">Careers</Link></li>
              <li><Link to="/">Press</Link></li>
              <li><Link to="/">Blog</Link></li>
            </ul>
          </div>

          {/* Center - Logo & Branding */}
          <div className="footer-center">
            <div className="footer-logo-subtitle">Premium Shopping</div>
            <h2 className="footer-logo">
              SPLENDRO<span className="gold-text">FIY</span>
            </h2>
            <p className="footer-tagline">
              Découvrez l'excellence en chaque produit. Sélection soignée pour votre style de vie.
            </p>
          </div>

          {/* Right Section - Shop & Support */}
          <div className="footer-right">
            <div className="footer-section">
              <h6>Magasiner</h6>
              <ul>
                <li><Link to="/category/AllProducts">Tous les Produits</Link></li>
                <li><Link to="/category/Beauty">Beauté</Link></li>
                <li><Link to="/category/Electronique">Électronique</Link></li>
                <li><Link to="/category/Sports">Sports</Link></li>
                <li><Link to="/category/Coffrets">Coffrets</Link></li>
              </ul>
            </div>

            <div className="footer-section">
              <h6>Support</h6>
              <ul>
                <li><Link to="/">Politique d'Expédition</Link></li>
                <li><Link to="/">Retours & Remboursements</Link></li>
                <li><Link to="/contact">Nous Contacter</Link></li>
                <li><Link to="/">FAQ</Link></li>
              </ul>
            </div>
          </div>
        </div>

        
      </div>
    </footer>
  );
}

export default Footer;